export { default as RectangleSelector } from './hocs/RectangleSelector';
export { default as PointSelector } from './hocs/PointSelector';
export { default as OvalSelector } from './hocs/OvalSelector';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-image-annotation/es/selectors.js
// module id = 2028
// module chunks = 0